














import { Component, Vue, Prop } from 'vue-property-decorator';
import InputParts from '@/components/molecules/InputParts.vue';
import Kanban from '@/components/atoms/Kanban.vue';
import BtnBase from '@/components/atoms/BtnBase.vue';
import { CustomerEmailConfirmationRequest } from '@/types/api/types-api';
import { TypeInputParts } from '@/types/components/types-parts';
import { PartsHelper } from '@/helpers/parts';
import { ValidationHelper } from '@/helpers/validate';
import { ErrorHelper } from '@/helpers/error';
import { VueHelper } from '@/helpers/vue';
import { HttpStatus, InputEventType } from '@/types/converter/convert';
import { Const } from '@/const/const';

@Component({
    components: {
        Kanban,
        BtnBase,
        InputParts
    },
})
export default class PRS0000001EmailConfirmation extends Vue {

    @Prop() private provisionShopCode!: string;
    @Prop() private backUrlCode!: string
    @Prop() private backUrlPrm!: string

    mailInputParts: TypeInputParts = PartsHelper.createInputParts("メールアドレス", "email", InputEventType.NONE, true, "(例)xxxxx@xxxxx.xxxxx", 100)

    async send () {
        if (!this.beforeCheck()) {
            return
        }
        const request: CustomerEmailConfirmationRequest = new CustomerEmailConfirmationRequest(
            this.mailInputParts.value,
            this.provisionShopCode,
            this.backUrlCode,
            encodeURIComponent(this.backUrlPrm)
        )
        VueHelper.lock()
        const response: any = await this.$api.postCustomerMailConfirmation(request);
        VueHelper.unlock()

        if (response.status === HttpStatus.OK.code) {
            VueHelper.move(this, '/email-complete?provision_shop_code=' + this.provisionShopCode)
        } else {
            if (response.status === HttpStatus.CONFLICT.code) {
                this.mailInputParts.error = Const.ERROR_MESSAGE_EXIST_EMAIL
                return
            } else {
                ErrorHelper.apiErrorHandler(
                    response,
                    this,
                    [
                        this.mailInputParts
                    ]
                )
            }
        }
    }

    beforeCheck (): boolean {
        return ValidationHelper.requiredInputParts(this.mailInputParts)
    }

    // Action Press Back Button
    backToppage() {
        VueHelper.historyBack(this)
    }
}
